// 대운 전환 유형 표(승인됨). 원본은 이 파일 하나다. 검사: node ai/scripts/check-links.mjs
// 고서 원문 확인 전이라 needsCheck 를 유지한다. 승인 전 초안이던 ai/knowledge/luck-transitions.draft.json 은 이 파일로 옮겼다.
export const LUCK_TRANSITIONS = {
  "status": "approved-by-user",
  "note": "대운 전환 유형 표. 사용자가 2026-10-19에 분류를 승인했다(예외 3칸 포함). 고서 원문 확인은 아직 하지 않았으므로 needsCheck 를 유지한다. 분류는 오행 생극 관계와 '순용은 생하는 흐름, 역용은 제어하는 흐름'에서 이끌어 낸 게임 규칙이며 고서의 수치가 아니다. 이 파일이 유일한 원본이고 ai/scripts/check-links.mjs 가 검사한다.",
  "types": {
    "돕는": "새 대운의 십성이 격국의 쓰임을 키워 주는 시기. 기회를 이어 가기 좋은 환경",
    "막는": "새 대운의 십성이 격국과 부딪치거나 성질을 지나치게 키우는 시기. 손실·충돌 사건이 나올 수 있고, 지금 일이 맞지 않으면 전직 기회도 열리는 환경",
    "바꾸는": "격국의 방향을 다시 정리해야 하는 시기. 전직·역할 전환 기회가 열리는 환경"
  },
  "relations": {
    "같은십성": "대운 천간의 십성이 격국 십성과 같다",
    "같은그룹다른십성": "같은 영역(예: 정관과 편관)이지만 십성이 다르다",
    "대운이격국을생": "대운 영역이 격국 영역을 생한다 (오행 상생에서 대운 → 격국)",
    "대운이격국을극": "대운 영역이 격국 영역을 극한다",
    "격국이대운을생": "격국 영역이 대운 영역을 생한다 (격국 → 대운)",
    "격국이대운을극": "격국 영역이 대운 영역을 극한다"
  },
  "table": {
    "순용": {
      "같은십성": {
        "type": "돕는",
        "reason": "순하게 쓰는 격이 같은 기운을 더 얻는다"
      },
      "같은그룹다른십성": {
        "type": "바꾸는",
        "reason": "정·편이 섞여 방향을 다시 정리해야 한다"
      },
      "대운이격국을생": {
        "type": "돕는",
        "reason": "순용 격은 생해 주는 기운에서 힘을 얻는다 (예: 재가 관을 생함)"
      },
      "대운이격국을극": {
        "type": "막는",
        "reason": "순용 격을 극하는 기운은 쓰임을 해친다 (예: 상관이 관을 해침)"
      },
      "격국이대운을생": {
        "type": "돕는",
        "reason": "격이 생한 기운이 쓸 곳이 된다 (예: 식신이 재를 생함)"
      },
      "격국이대운을극": {
        "type": "바꾸는",
        "reason": "격이 대운의 기운을 누르며 역할을 바꾸게 된다"
      }
    },
    "역용": {
      "같은십성": {
        "type": "막는",
        "reason": "거친 성질의 격이 같은 기운을 더 얻어 지나치게 커진다"
      },
      "같은그룹다른십성": {
        "type": "바꾸는",
        "reason": "정·편이 섞여 방향을 다시 정리해야 한다"
      },
      "대운이격국을생": {
        "type": "막는",
        "reason": "역용 격은 생해 주면 성질이 더 커진다 (예: 재가 살을 생함)"
      },
      "대운이격국을극": {
        "type": "돕는",
        "reason": "역용 격은 극해서 제어해 주는 기운에서 쓰임이 난다 (예: 인이 상관을 제어함)"
      },
      "격국이대운을생": {
        "type": "돕는",
        "reason": "격이 생한 기운이 쓸 곳이 된다 (예: 상관이 재를 생함)"
      },
      "격국이대운을극": {
        "type": "막는",
        "reason": "거친 격이 대운의 기운과 정면으로 부딪친다 (예: 상관이 관을 만남)"
      }
    }
  },
  "cardIds": [
    "JP-순용역용",
    "DC-luck"
  ],
  "needsCheck": true,
  "separate": "건록격·월겁격은 순용·역용이 아닌 별도 축이라 이 표를 쓰지 않는다. 유형은 null 이다.",
  "overrides": {
    "note": "관계 12칸으로 정해지는 값을 격국×대운 십성 한 칸 단위로 덮어쓰는 예외. 사용자가 지정한 3칸. 원전 확인 전이다.",
    "정관격": {
      "편관": {
        "type": "막는",
        "reason": "정관격에 편관 대운이 들어와 관과 살이 섞인다 (관살혼잡)"
      }
    },
    "편관격": {
      "정관": {
        "type": "막는",
        "reason": "편관격에 정관 대운이 들어와 관과 살이 섞인다 (관살혼잡)"
      }
    },
    "상관격": {
      "편관": {
        "type": "돕는",
        "reason": "상관이 편관(칠살)을 제어하는 흐름이다 (상관제살)"
      }
    }
  },
  "approvedOn": "2026-10-19",
  "labels": {
    "돕는": "기회를 키우는 시기",
    "막는": "부딪치기 쉬운 시기",
    "바꾸는": "방향을 다시 정하는 시기"
  }
};
